<template>
  <span>
    <v-dialog v-model="dialog" width="600">
      <template v-slot:activator="{ on }">
        <v-btn outlined :icon="!activatorLabel" v-on="on">
          <v-icon>{{activatorIcon ? activatorIcon:'mdi-plus'}}</v-icon>
          {{activatorLabel}}
        </v-btn>
      </template>

      <v-card width="100%" class="mx-auto">
        <v-card-title>{{title || 'Add Teacher to Course'}}</v-card-title>
        <v-card-text class="mt-5">
          <v-select v-model="teacher" :items="teachers" item-value="id" item-text="name" label="Teacher"/>
          <v-checkbox v-model="inviteGoogleClassroom" value="true" label="Invite on Google Classroom"/>
          <v-checkbox v-model="addOnGoogleCalendar" value="true" label="Add to guest on Google Calendar"/>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn @click="selectedTeacher">Select Teacher</v-btn>
          <v-spacer/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  props:{
    activatorIcon: {
      type: String,
      required: false,
    },
    activatorLabel: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
    registered: {
      type: Boolean,
      required: false,
      default: true
    },
  },
  data() {
    return {
      dialog: false,
      teachers: [],
      teacher: null,
      inviteGoogleClassroom: false,
      addOnGoogleCalendar: false
    };
  },
  watch: {
    dialog(show) {
      if (show) {
        this.loadTeachers();
      }
    },
  },
  computed: {
    ...mapGetters(["isAppLoading"]),
  },
  methods: {
    ...mapActions(["addErrorMessage"]),
    loadTeachers() {
      const data = {
        pageSize: 100,
        sortInfos: [{ sortCol: 'firstName', sortDir: 'asc'}],
        registered: this.registered
      };

      this.$axios
        .post("/teacher/search", data)
        .then(resp => {
          this.teachers = resp.data.data.content.map( t => {return Object.assign( {name: `${t.firstName} ${t.lastName}`}, t) });
        })
        .catch(() => {
          this.addErrorMessage("Error loading teachers from server");
        });

    },
    openDialog(event) {
      this.$emit("onOpen", event);
    },
    selectedTeacher() {

    const googleServices = {
        classroom: this.inviteGoogleClassroom,
        calendar: this.addOnGoogleCalendar
      }
      const teacher = this.teachers.find( t => t.id == this.teacher);
      this.$emit("selectedTeacher", teacher, googleServices);

      this.dialog = false;
    }
  },
  mounted() {
  }
};
</script>

<style>
</style>